import { render } from "./CareerPathPlanning.vue?vue&type=template&id=bdd38904"
import script from "./CareerPathPlanning.vue?vue&type=script&lang=js"
export * from "./CareerPathPlanning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__